// API Configuration
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

import { API_BASE_URL } from "./api";

export const API_CONFIG = {
  baseUrl: API_BASE_URL,
  timeout: 300000, // 300 seconds (5 minutes)
  headers: {
  },
};

export default API_CONFIG;